import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/role/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/role/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/role/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/role/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/role/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/role/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/role/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/role/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/role/update/batch',
    method: 'POST',
    data})
}

   